import React from 'react';
import PropTypes from 'prop-types';
import MuiChip from '@mui/material/Chip';

const Chip = ({className, color, label, size, sx}) => {
    return (
        <MuiChip
            className={className}
            color={color}
            label={label}
            size={size}
            sx={sx}
        />
    );
};

Chip.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    label: PropTypes.node,
    size: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]),
};

export default Chip;
